import React from 'react';

import Container from './Container.jsx';
import { default as _TypeConfig } from './TypeConfig.jsx';
import Utilities from '../utility/Utilities.jsx';

function ListContainer(props) {
    let className = 'editable list-cont';
    if (props.className) {
        className += ` ${props.className}`;
    }
    const data = props.data || {};
    const blockProps = props.config && props.config.config && props.config.config.Block || {};
    const borderProps = {};
    if (blockProps.borderLeftWidth && !Utilities.isNullOrWhitespace(blockProps.borderLeftWidth.value)) {
        borderProps.borderLeftColor = blockProps.borderLeftColor;
        borderProps.borderLeftStyle = blockProps.borderLeftStyle;
        borderProps.borderLeftWidth = `${blockProps.borderLeftWidth.value}${blockProps.borderLeftWidth.unit}`;
    }
    if (blockProps.borderRightWidth && !Utilities.isNullOrWhitespace(blockProps.borderRightWidth.value)) {
        borderProps.borderRightColor = blockProps.borderRightColor;
        borderProps.borderRightStyle = blockProps.borderRightStyle;
        borderProps.borderRightWidth = `${blockProps.borderRightWidth.value}${blockProps.borderRightWidth.unit}`;
    }
    let borderTop;
    if (blockProps.borderTopWidth && !Utilities.isNullOrWhitespace(blockProps.borderTopWidth.value)) {
        const borderStyle = { ...borderProps, borderTopColor: blockProps.borderTopColor, borderTopStyle: blockProps.borderTopStyle, borderTopWidth: `${blockProps.borderTopWidth.value}${blockProps.borderTopWidth.unit}` };
        if (blockProps.borderTopSpacing && !Utilities.isNullOrWhitespace(blockProps.borderTopSpacing.value)) {
            borderStyle.paddingBottom = `${blockProps.borderTopSpacing.value}${blockProps.borderTopSpacing.unit}`;
        }
        borderTop = <tr><td style={borderStyle} /></tr>
        if (!props.builder) {
            borderTop = (
                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                    <tbody>
                        {borderTop}
                    </tbody>
                </table>
            )
        }
    }
    let borderBottom;
    if (blockProps.borderBottomWidth && !Utilities.isNullOrWhitespace(blockProps.borderBottomWidth.value)) {
        const borderStyle = { ...borderProps, borderBottomColor: blockProps.borderBottomColor, borderBottomStyle: blockProps.borderBottomStyle, borderBottomWidth: `${blockProps.borderBottomWidth.value}${blockProps.borderBottomWidth.unit}` };
        if (blockProps.borderBottomSpacing && !Utilities.isNullOrWhitespace(blockProps.borderBottomSpacing.value)) {
            borderStyle.paddingTop = `${blockProps.borderBottomSpacing.value}${blockProps.borderBottomSpacing.unit}`;
        }
        borderBottom = <tr><td style={borderStyle} /></tr>
        if (!props.builder) {
            borderBottom = (
                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                    <tbody>
                        {borderBottom}
                    </tbody>
                </table>
            )
        }
    }
    let bottomSpacer, topSpacer;
    if (!props.builder) {
        if (props.config.config.Style && props.config.config.Style.paddingTop && !Utilities.isNullOrWhitespace(props.config.config.Style.paddingTop.value)) {
            topSpacer = (
                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                    <tbody>
                        <tr><td style={{ paddingTop: `${props.config.config.Style.paddingTop.value}${props.config.config.Style.paddingTop.unit}` }} /></tr>
                    </tbody>
                </table>
            )
        }
        if (props.config.config.Style && props.config.config.Style.paddingBottom && !Utilities.isNullOrWhitespace(props.config.config.Style.paddingBottom.value)) {
            bottomSpacer = (
                <table border="0" cellPadding="0" cellSpacing="0" width="100%">
                    <tbody>
                        <tr><td style={{ paddingBottom: `${props.config.config.Style.paddingBottom.value}${props.config.config.Style.paddingBottom.unit}` }} /></tr>
                    </tbody>
                </table>
            )
        }
    }
    const CellComponent = props.cellComponent;
    const visibilityHash = Utilities.Config.getVisibilityHash({ block: props.config });
    let content = (
        <>
            {topSpacer}
            {props.header}
            {borderTop}
            {
                CellComponent &&
                props.records &&
                props.records.map((record, i) =>
                    <CellComponent
                        key={i}
                        blockProps={blockProps}
                        borderProps={borderProps}
                        builder={props.builder}
                        config={blockProps.design}
                        count={props.records.length}
                        data={data}
                        forceVisibility={props.forceVisibility}
                        index={i}
                        kit={props.kit}
                        record={record}
                        serverSide={props.serverSide}
                        visibility={props.config && props.config.config && props.config.config.Visibility}
                        visibilityHash={visibilityHash}
                        onBlockExtras={props.onBlockExtras} />
                )
            }
            {
                props.builder &&
                <tr>
                    <td>
                        {
                            (!props.records || props.records.length == 0) &&
                            Utilities.Builder.emptyBlockPlaceholder()
                        }
                        {Utilities.Builder.dragOutline()}
                    </td>
                </tr>
            }
            {borderBottom}
            {bottomSpacer}
        </>
    )
    if (props.builder) {
        content = (
            <Container
                builder={props.builder}
                className={className}
                config={props.config}
                onClick={props.onClick}
                onDragEnter={props.onDragEnter}
                onDragStart={props.onDragStart}>
                {content}
            </Container>
        )
    }
    return content;
}

const TypeConfig = {
    panel: {
        block: (cellType, options = {}) => {
            const group = 'block';
            return {
                group,
                label: 'Design',
                options: [
                    {
                        display: 'Edit List Design',
                        fullWidth: true,
                        group,
                        offsetTop: true,
                        type: 'edit-button',
                        value: {
                            keyPath: ['Block', 'design'],
                            name: cellType
                        }
                    },
                    {
                        display: 'Item Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'itemSpacing',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider',
                        value: options.itemSpacing || { "unit": "px", "value": "40" }
                    },
                    {
                        display: 'Item Separator Color',
                        group,
                        name: 'itemSeparatorColor',
                        type: 'color-left',
                        value: '#e9e9e9'
                    },
                    {
                        display: 'Item Separator Size',
                        group,
                        name: 'itemSeparatorSize',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement',
                        value: options.itemSeparatorSize || { "unit": "px", "value": "1" }
                    },
                    {
                        display: 'Content Border',
                        group,
                        name: 'border',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'border'
                    },
                    {
                        display: 'Top Border Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'borderTopSpacing',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    },
                    {
                        display: 'Bottom Border Spacing',
                        fullWidth: true,
                        group,
                        max: '100',
                        name: 'borderBottomSpacing',
                        options: _TypeConfig.dropdown.measurement(),
                        type: 'measurement-slider'
                    }
                ]
            };
        },
        style: () => _TypeConfig.panel.layoutStyle('block', undefined, {}, undefined, {})
    }
}

export {
    ListContainer as Component,
    TypeConfig
}